exports.tokens = {
  "Black": "#000000",
  "White": "#ffffff",
  "Brand25": "#faf9f5",
  "Brand50": "#f8f4ec",
  "Brand100": "#f6eddd",
  "Brand200": "#f3e5ce",
  "Brand300": "#f1debf",
  "Brand400": "#e4d1b2",
  "Brand500": "#d8c5a5",
  "Brand600": "#cbb898",
  "Brand700": "#c2ad86",
  "Brand800": "#baa173",
  "Brand900": "#b19661",
  "Digital25": "#f4f3fc",
  "Digital50": "#dedefb",
  "Digital100": "#bcbdf6",
  "Digital200": "#9b9cf2",
  "Digital300": "#7a7cee",
  "Digital400": "#585be9",
  "Digital500": "#373ae5",
  "Digital600": "#292cb7",
  "Digital700": "#1b1d88",
  "Digital800": "#0e0f59",
  "Digital900": "#00012b",
  "Gray25": "#f5f5f5",
  "Gray50": "#e8e8e8",
  "Gray100": "#d1d1d1",
  "Gray200": "#b9b9b9",
  "Gray300": "#a2a2a2",
  "Gray400": "#8b8b8b",
  "Gray500": "#747474",
  "Gray600": "#5d5d5d",
  "Gray700": "#464646",
  "Gray800": "#2e2e2e",
  "Gray900": "#171717",
  "Red25": "#FEE6E6",
  "Red50": "#FDCECC",
  "Red100": "#FDB5B3",
  "Red200": "#FC9C99",
  "Red300": "#FA6B66",
  "Red400": "#F93933",
  "Red500": "#f70800",
  "Red600": "#C60600",
  "Red700": "#940500",
  "Red800": "#630300",
  "Red900": "#310200",
  "Green25": "#E6F9EF",
  "Green50": "#CCF3DE",
  "Green100": "#B3EECE",
  "Green200": "#99E8BD",
  "Green300": "#66DC9C",
  "Green400": "#33D17B",
  "Green500": "#00c55a",
  "Green600": "#009E48",
  "Green700": "#007636",
  "Green800": "#004F24",
  "Green900": "#002712",
  "Orange25": "#FFF5E6",
  "Orange50": "#FFEBCC",
  "Orange100": "#FFE0B3",
  "Orange200": "#FFD699",
  "Orange300": "#FFC266",
  "Orange400": "#FFAD33",
  "Orange500": "#FF9900",
  "Orange600": "#CC7A00",
  "Orange700": "#995C00",
  "Orange800": "#663D00",
  "Orange900": "#331F00",
  "GradientsDigitalBlue": "linear-gradient(206deg, #373ae5 0%, #292cb7 52.08%)",
  "GradientsGold": "linear-gradient(213deg, #f7edde 0%, #b19661 100%)",
  "GradientsCosmopolitan": "linear-gradient(206deg, #902F9D 0%, #73267E 52.08%)",
  "GradientsImgCarousel": "linear-gradient(0deg, #000000B3 0%, #0000008C 18%, #5D5D5D26 62%, #5D5D5D00 88%)",
  "SecondaryYellow25": "#fcf3e7",
  "SecondaryYellow50": "#f8e7d0",
  "SecondaryYellow100": "#f5dbb8",
  "SecondaryYellow200": "#f2d0a0",
  "SecondaryYellow300": "#efc488",
  "SecondaryYellow400": "#ebb871",
  "SecondaryYellow500": "#e8ac59",
  "SecondaryYellow600": "#dfa051",
  "SecondaryYellow700": "#d79449",
  "SecondaryYellow800": "#ce8741",
  "SecondaryYellow900": "#c57b39",
  "SecondaryTeal25": "#f2f8f8",
  "SecondaryTeal50": "#cae6e1",
  "SecondaryTeal100": "#a1d4cb",
  "SecondaryTeal200": "#79c2b4",
  "SecondaryTeal300": "#51b09e",
  "SecondaryTeal400": "#289e88",
  "SecondaryTeal500": "#008c71",
  "SecondaryTeal600": "#057b66",
  "SecondaryTeal700": "#0a695a",
  "SecondaryTeal800": "#0f584f",
  "SecondaryTeal900": "#144643",
  "SecondaryPurple25": "#faf4fc",
  "SecondaryPurple50": "#e6d2ea",
  "SecondaryPurple100": "#d1b0d9",
  "SecondaryPurple200": "#bd8ec8",
  "SecondaryPurple300": "#a96bb6",
  "SecondaryPurple400": "#9449a5",
  "SecondaryPurple500": "#802793",
  "SecondaryPurple600": "#6d2281",
  "SecondaryPurple700": "#5a1e6f",
  "SecondaryPurple800": "#47195c",
  "SecondaryPurple900": "#34144a",
  "FontfamilyBrand": "Calibre-R",
  "Lineheight1": "100%",
  "Lineheight2": "135%",
  "Lineheight3": "150%",
  "Fontweight400": "Regular",
  "Fontweight500": "Medium",
  "Fontweight600": "Semibold",
  "FontsizeXs": "12",
  "FontsizeS": "14",
  "FontsizeM": "16",
  "FontsizeL": "18",
  "FontsizeXl": "20",
  "Fontsize2xl": "24",
  "Fontsize3xl": "30",
  "Fontsize4xl": "36",
  "Fontsize5xl": "48",
  "Fontsize6xl": "60",
  "Fontsize7xl": "72",
  "Fontsize8xl": "96",
  "Fontsize9xl": "128",
  "Fontsize10xl": "171",
  "Fontsize11x": "227",
  "Letterspacing0": "0%",
  "Paragraphspacing0": "0%",
  "LabelRegularXs": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "12",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelMediumXs": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "12",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelSemiboldXs": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Semibold",
    "lineHeight": "100%",
    "fontSize": "12",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelRegularS": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelMediumS": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelSemiboldS": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Semibold",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelRegularM": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelMediumM": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelSemiboldM": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Semibold",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelRegularXl": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelRegularL": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "18",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "none",
    "textCase": "none"
  },
  "LabelMediumL": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "18",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "none",
    "textCase": "none"
  },
  "LabelMediumXl": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "LabelSemiboldXl": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Semibold",
    "lineHeight": "100%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodyRegularXs": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "12",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodyMediumXs": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "12",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodySemiboldXs": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Semibold",
    "lineHeight": "135%",
    "fontSize": "12",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodyRegularS": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodyMediumS": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodySemiboldS": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Semibold",
    "lineHeight": "135%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodyRegularM": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodyMediumM": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodySemiboldM": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Semibold",
    "lineHeight": "135%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodyRegularXl": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodyMediumXl": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodySemiboldXl": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Semibold",
    "lineHeight": "135%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "BodyMediumL": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "18",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "none",
    "textCase": "none"
  },
  "HeadingMedium6": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "60",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingRegular6": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "60",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingRegular5": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "48",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingMedium5": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "48",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingMedium4": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "36",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingRegular4": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "36",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingMedium3": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "30",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingRegular3": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "30",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingMedium2": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "24",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingRegular2": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "24",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingMedium1": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "HeadingRegular1": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "TextcaseNone": "none",
  "TextdecorationNone": "none",
  "TextdecorationUnderline": "underline",
  "TextdecorationLineThrough": "line-through",
  "BrSmall": "4",
  "BrMedium": "8",
  "BrLarge": "16",
  "LinkRegularXs": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "12",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "LinkRegularS": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "LinkRegularM": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "LinkMediumS": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "LinkMediumM": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "Size1x": "8px",
  "Size2x": "16px",
  "Size3x": "24px",
  "Size4x": "32px",
  "Size5x": "40px",
  "Size6x": "48px",
  "Size7x": "56px",
  "Size8x": "64px",
  "Size9x": "72px",
  "Size10x": "80px",
  "Size11x": "88px",
  "Size12x": "96px",
  "Space0x": "0",
  "Space05x": "4",
  "Space1x": "8",
  "Space2x": "16",
  "Space3x": "24",
  "Space4x": "32",
  "Space5x": "40",
  "Space6x": "48",
  "Space7x": "56",
  "Space8x": "64",
  "Space9x": "72",
  "Space10x": "80",
  "BorderWidthThin": "1",
  "BorderWidthMedium": "1.5",
  "BorderWidthThick": "2",
  "BorderWidthExtraThin": "0.5",
  "TransparentDefault": "#00000000",
  "TransparentBrand": "#b1966133",
  "TransparentDigital": "#373ae51a",
  "TransparentSubtle": "#ffffff80",
  "TransparentDark": "#00000066",
  "AspectRatio1x1": "1",
  "AspectRatio4x3": "1.3333",
  "AspectRatio3x4": "0.75",
  "AspectRatio3x2": "1.5",
  "AspectRatio2x3": "0.6666",
  "AspectRatio16x9": "1.7777",
  "AspectRatio9x16": "0.5625",
  "AspectRatio2x1": "2",
  "AspectRatio1x2": "0.5",
  "BrNone": "0",
  "ShadowInteractive": {
    "x": "2",
    "y": "2",
    "blur": "8",
    "spread": "0",
    "color": "#373ae51a",
    "type": "dropShadow"
  },
  "ShadowElevation1": {
    "x": "0",
    "y": "1",
    "blur": "6",
    "spread": "0",
    "color": "#b1966133",
    "type": "dropShadow"
  },
  "ShadowElevation2": {
    "x": "0",
    "y": "2",
    "blur": "16",
    "spread": "0",
    "color": "#b1966133",
    "type": "dropShadow"
  },
  "ShadowNone": {
    "x": "0",
    "y": "0",
    "blur": "0",
    "spread": "0",
    "color": "#00000000",
    "type": "innerShadow"
  },
  "ShadowElevation3": {
    "x": "0",
    "y": "3",
    "blur": "8",
    "spread": "0",
    "color": "#0000001a",
    "type": "dropShadow"
  },
  "ShadowElevation4": {
    "x": "0",
    "y": "-3",
    "blur": "8",
    "spread": "0",
    "color": "#0000001a",
    "type": "dropShadow"
  },
  "Opacity0": "0%",
  "Opacity10": "10%",
  "Opacity20": "20%",
  "Opacity25": "25%",
  "Opacity30": "30%",
  "Opacity40": "40%",
  "Opacity50": "50%",
  "Opacity60": "60%",
  "Opacity70": "70%",
  "Opacity80": "80%",
  "Opacity90": "90%",
  "Opacity100": "100%",
  "RewardsSapphire": "#2D5E75",
  "RewardsPearl": "#EBE7E9",
  "RewardsGold": "#BDA770",
  "RewardsPlatinum": "#757275",
  "RewardsNoir": "#000000",
  "MotionDuration0": "0 ms",
  "MotionDuration25": "25 ms",
  "MotionDuration50": "50 ms",
  "MotionDuration75": "75 ms",
  "MotionDuration100": "100 ms",
  "MotionDuration125": "125 ms",
  "MotionDuration150": "150 ms",
  "MotionDuration175": "175 ms",
  "MotionDuration200": "200 ms",
  "MotionDuration225": "225 ms",
  "MotionDuration250": "250 ms",
  "MotionDuration275": "275 ms",
  "MotionDuration300": "300 ms",
  "MotionDuration325": "325 ms",
  "MotionDuration350": "350 ms",
  "MotionDuration375": "375 ms",
  "MotionDuration400": "400 ms",
  "MotionDuration425": "425 ms",
  "MotionDuration450": "450 ms",
  "MotionDuration475": "475 ms",
  "MotionDuration500": "500 ms",
  "MotionDuration525": "525 ms",
  "MotionDuration550": "550 ms",
  "MotionDuration575": "575 ms",
  "MotionDuration600": "600 ms",
  "MotionDuration625": "625 ms",
  "MotionDuration650": "650 ms",
  "MotionDuration675": "675 ms",
  "MotionDuration700": "700 ms",
  "MotionDuration725": "725 ms",
  "MotionDuration750": "750 ms",
  "MotionDuration775": "775 ms",
  "MotionDuration800": "800 ms",
  "MotionDuration825": "825 ms",
  "MotionDuration850": "850 ms",
  "MotionDuration875": "875 ms",
  "MotionDuration900": "900 ms",
  "MotionDuration925": "925 ms",
  "MotionDuration950": "950 ms",
  "MotionDuration975": "975 ms",
  "MotionDuration1000": "1000 ms",
  "MotionDuration1025": "1025 ms",
  "MotionDuration1050": "1050 ms",
  "MotionDuration1075": "1075 ms",
  "MotionDuration1100": "1100 ms",
  "MotionDuration1125": "1125 ms",
  "MotionDuration1150": "1150 ms",
  "MotionDuration1175": "1175 ms",
  "MotionDuration1200": "1200 ms",
  "MotionDuration1225": "1225 ms",
  "MotionDuration1250": "1250 ms",
  "MotionDuration1275": "1275 ms",
  "MotionDuration1300": "1300 ms",
  "MotionDuration1325": "1325 ms",
  "MotionDuration1350": "1350 ms",
  "MotionDuration1375": "1375 ms",
  "MotionDuration1400": "1400 ms",
  "MotionDuration1425": "1425 ms",
  "MotionDuration1450": "1450 ms",
  "MotionDuration1475": "1475 ms",
  "MotionDuration1500": "1500 ms",
  "MotionDuration1525": "1525 ms",
  "MotionDuration1550": "1550 ms",
  "MotionDuration1575": "1575 ms",
  "MotionDuration1600": "1600 ms",
  "MotionDuration1625": "1625 ms",
  "MotionDuration1650": "1650 ms",
  "MotionDuration1675": "1675 ms",
  "MotionDuration1700": "1700 ms",
  "MotionDuration1725": "1725 ms",
  "MotionDuration1750": "1750 ms",
  "MotionDuration1775": "1775 ms",
  "MotionDuration1800": "1800 ms",
  "MotionDuration1825": "1825 ms",
  "MotionDuration1850": "1850 ms",
  "MotionDuration1875": "1875 ms",
  "MotionDuration1900": "1900 ms",
  "MotionDuration1925": "1925 ms",
  "MotionDuration1950": "1950 ms",
  "MotionDuration1975": "1975 ms",
  "MotionDuration2000": "2000 ms",
  "MotionEasingLinear": "0, 0, 1, 1",
  "MotionEasingCubic": "0.66, 0, 0.34, 1",
  "MotionEasingCubicIn": "0.40, 0.00, 0.68, 0.06",
  "MotionEasingCubicOut": "0.32, 0.94, 0.60, 1.00",
  "MotionEasingQuint": "0.84, 0, 0.16, 1",
  "MotionEasingQuintIn": "0.64, 0.00, 0.78, 0.00",
  "MotionEasingQuintOut": "0.22, 1.00, 0.36, 1.00",
  "MotionEasingBack": "0.68, -0.55, 0.27, 1.55",
  "MotionEasingBackIn": "0.60, -0.28, 0.73, 0.04",
  "MotionEasingBackOut": "0.17, 0.89, 0.32, 1.27",
  "MotionEasingEase": "0.42, 0.00, 0.58, 1.00",
  "MotionEasingEaseIn": "0.42, 0.00, 1.00, 1.00",
  "MotionEasingEaseOut": "0.00, 0.00, 0.58, 1.00",
  "MotionEasingQuad": "0.48, 0.04, 0.52, 0.96",
  "MotionEasingQuadIn": "0.26, 0.00, 0.60, 0.20",
  "MotionEasingQuadOut": "0.40, 0.80, 0.74, 1.00",
  "MotionEasingQuart": "0.76, 0.00, 0.24, 1.00",
  "MotionEasingQuartIn": "0.52, 0.00, 0.74, 0.00",
  "MotionEasingQuartOut": "0.26, 1.00, 0.48, 1.00",
  "MotionEasingExpo": "0.90, 0.00, 0.10, 1.00",
  "MotionEasingExpoIn": "0.66, 0.00, 0.86, 0.00",
  "MotionEasingExpoOut": "0.14, 1.00, 0.34, 1.00",
  "MotionEasingCirc": "0.88, 0.14, 0.12, 0.86",
  "MotionEasingCircIn": "0.54, 0.00, 1.00, 0.44",
  "MotionEasingCircOut": "0.00, 0.56, 0.46, 1.00",
  "BreakpointXl": "1440",
  "BreakpointLg": "1024",
  "BreakpointMd": "768",
  "BreakpointSm": "640",
  "BreakpointXs": "375",
  "ContentWidthXl": "1440",
  "ContentWidthLg": "1024",
  "ContentWidthMd": "768",
  "ContentWidthSm": "640",
  "ContentWidthXs": "375",
  "PropertiesCosmopolitanPrimary25": "#EFEAF1",
  "PropertiesCosmopolitanPrimary50": "#DFD5E3",
  "PropertiesCosmopolitanPrimary100": "#D0C0D5",
  "PropertiesCosmopolitanPrimary200": "#C0ABC7",
  "PropertiesCosmopolitanPrimary300": "#A080AB",
  "PropertiesCosmopolitanPrimary400": "#81568F",
  "PropertiesCosmopolitanPrimary500": "#612C73",
  "PropertiesCosmopolitanPrimary600": "#4E235C",
  "PropertiesCosmopolitanPrimary700": "#3A1A45",
  "PropertiesCosmopolitanPrimary800": "#27122E",
  "PropertiesCosmopolitanPrimary900": "#1D0D23",
  "PropertiesCosmopolitanAlternative25": "#F4EAF5",
  "PropertiesCosmopolitanAlternative50": "#E9D5EB",
  "PropertiesCosmopolitanAlternative100": "#DDBCE1",
  "PropertiesCosmopolitanAlternative200": "#CA9BD0",
  "PropertiesCosmopolitanAlternative300": "#B56ABF",
  "PropertiesCosmopolitanAlternative400": "#A14BAD",
  "PropertiesCosmopolitanAlternative500": "#902F9D",
  "PropertiesCosmopolitanAlternative600": "#73267E",
  "PropertiesCosmopolitanAlternative700": "#561C5E",
  "PropertiesCosmopolitanAlternative800": "#3A133F",
  "PropertiesCosmopolitanAlternative900": "#1D091F",
  "PropertiesCosmopolitanTransparency10": "#902F9D1A",
  "PropertiesCosmopolitanTransparency20": "#902F9D33",
  "PropertiesCosmopolitanTransparency30": "#902F9D4D",
  "PropertiesCosmopolitanTransparency40": "#902F9D66",
  "PropertiesCosmopolitanTransparency50": "#902F9D80",
  "PropertiesCosmopolitanTransparency60": "#902F9D99",
  "PropertiesCosmopolitanTransparency70": "#902F9DB3",
  "PropertiesCosmopolitanTransparency80": "#902F9DCC",
  "PropertiesCosmopolitanTransparency90": "#902F9DE6",
  "PropertiesCosmopolitanTransparency100": "#902F9D"
}